<div
  class="custom-criteria-list"
  *ngIf="customer$ | async">
  <mat-card class="mat-elevation-z2">
    <mat-card-title>{{ "customCriteria" | i18n | titlecase }}</mat-card-title>
    <mat-card-content>
      <div
        class="row"
        *ngFor="
          let customCriteria of customCriteria$ | async;
          trackBy: trackById
        ">
        <div class="col">
          <div class="custom-criteria-row">
            <div class="custom-criteria-details">
              <span class="custom-criteria-type-label">
                <ng-container
                  *ngIf="customCriteria.type === customCriteriaTypeEnum.TOGGLE"
                  >{{ "customCriteriaTypeToggle" | i18n }}</ng-container
                >
                <ng-container
                  *ngIf="customCriteria.type === customCriteriaTypeEnum.SELECT"
                  >{{ "customCriteriaTypeSelect" | i18n }}</ng-container
                >
              </span>
              <mat-form-field>
                <mat-label>{{ "title" | i18n }}</mat-label>
                <input
                  matInput
                  required
                  [(ngModel)]="customCriteria.displayName"
                  (ngModelChange)="touchCustomCriteriaList()"
                  [name]="'displayName-' + customCriteria.id"
                  [attr.data-cy]="'displayName-' + customCriteria.id" />
              </mat-form-field>
              <div
                *ngIf="customCriteria.type === customCriteriaTypeEnum.SELECT"
                class="custom-criteria-type-details">
                <mat-checkbox
                  [(ngModel)]="customCriteria.multiple"
                  (ngModelChange)="touchCustomCriteriaList()"
                  [name]="'multiple-' + customCriteria.id"
                  [attr.data-cy]="'multiple-' + customCriteria.id">
                  {{ "multipleSelection" | i18n }}</mat-checkbox
                >
                <mat-checkbox
                  [ngModel]="customCriteria.enableOnJobRequest !== false"
                  (ngModelChange)="
                    customCriteria.enableOnJobRequest = $event;
                    touchCustomCriteriaList()
                  "
                  [name]="'enableOnJobRequest-' + customCriteria.id"
                  [attr.data-cy]="'enableOnJobRequest-' + customCriteria.id">
                  {{ "customCriteriaEnableOnJobRequest" | i18n }}
                </mat-checkbox>
              </div>
            </div>
            <div class="custom-criteria-fields">
              <ng-container
                *ngIf="customCriteria.type === customCriteriaTypeEnum.TOGGLE">
                <mat-checkbox
                  [ngModel]="customCriteria.userEditable !== false"
                  (ngModelChange)="
                    customCriteria.userEditable = $event;
                    touchCustomCriteriaList()
                  "
                  [name]="'userEditable-' + customCriteria.id"
                  [attr.data-cy]="'userEditable-' + customCriteria.id">
                  {{ "customCriteriaUserEditable" | i18n }}
                </mat-checkbox>
                <mat-checkbox
                  [ngModel]="customCriteria.enableOnJobRequest !== false"
                  (ngModelChange)="
                    customCriteria.enableOnJobRequest = $event;
                    touchCustomCriteriaList()
                  "
                  [name]="'enableOnJobRequest-' + customCriteria.id"
                  [attr.data-cy]="'enableOnJobRequest-' + customCriteria.id">
                  {{ "customCriteriaEnableOnJobRequest" | i18n }}
                </mat-checkbox>
                <mat-slide-toggle
                  [(ngModel)]="customCriteria.defaultValueOnJob"
                  (ngModelChange)="touchCustomCriteriaList()"
                  [name]="'defaultValueOnJob-' + customCriteria.id"
                  [attr.data-cy]="'defaultValueOnJob-' + customCriteria.id">
                  {{ "defaultValueForJob" | i18n }}</mat-slide-toggle
                >
                <mat-slide-toggle
                  [(ngModel)]="customCriteria.defaultValueOnProfile"
                  (ngModelChange)="touchCustomCriteriaList()"
                  [name]="'defaultValueOnProfile-' + customCriteria.id"
                  [attr.data-cy]="'defaultValueOnProfile-' + customCriteria.id">
                  {{ "defaultValueForPooler" | i18n }}</mat-slide-toggle
                >
                <mat-checkbox
                  [ngModel]="customCriteria.blockingToggle !== false"
                  (ngModelChange)="
                    customCriteria.blockingToggle = $event;
                    touchCustomCriteriaList()
                  "
                  [name]="'blockingToggle-' + customCriteria.id"
                  [attr.data-cy]="'blockingToggle-' + customCriteria.id">
                  {{ "customCriteriaBlockingToggle" | i18n }}
                </mat-checkbox>
              </ng-container>
              <ng-container
                *ngIf="customCriteria.type === customCriteriaTypeEnum.SELECT">
                <div class="custom-criteria-options">
                  <div
                    class="custom-criteria-option-row"
                    *ngFor="
                      let option of customCriteria.options;
                      let optionIndex = index;
                      trackBy: trackByOptionId
                    ">
                    <mat-form-field class="custom-criteria-option-field">
                      <mat-label>{{ "title" | i18n }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="option.displayName"
                        (ngModelChange)="touchCustomCriteriaList()"
                        [name]="'opt-' + customCriteria.id + '-' + optionIndex"
                        [attr.data-cy]="
                          'opt-' + customCriteria.id + '-' + optionIndex
                        " />
                    </mat-form-field>
                    <button
                      class="custom-criteria-button delete-button"
                      mat-button
                      type="button"
                      (click)="
                        removeCriterionSelectOption(customCriteria, optionIndex)
                      "
                      [matTooltip]="'remove' | i18n">
                      <mat-icon
                        class="custom-criteria-button-icon"
                        svgIcon="delete-trash-remove"></mat-icon>
                    </button>
                  </div>
                  <button
                    class="outline-pill-button icon-left"
                    type="button"
                    (click)="addCriterionSelectOption(customCriteria)">
                    <mat-icon
                      class="custom-text-icon-button-icon"
                      svgIcon="add-circle-plus"></mat-icon>
                    {{ "addOption" | i18n }}
                  </button>
                </div>
              </ng-container>
            </div>
            <div class="custom-criteria-buttons">
              <button
                class="custom-criteria-button"
                mat-button
                type="button"
                (click)="cancelChanges(customCriteria.id)"
                [matTooltip]="'cancel' | i18n">
                <mat-icon
                  class="custom-criteria-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="custom-criteria-button save-button"
                mat-button
                type="button"
                (click)="saveCustomCriteria(customCriteria.id)"
                [matTooltip]="'save' | i18n">
                <mat-icon
                  class="custom-criteria-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
              <button
                class="custom-criteria-button delete-button"
                mat-button
                type="button"
                (click)="deleteCustomCriteria(customCriteria.id)"
                [matTooltip]="'remove' | i18n">
                <mat-icon
                  class="custom-criteria-button-icon"
                  svgIcon="delete-trash-remove"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngFor="let draft of customCriteriaInCreation$ | async; let i = index">
        <div class="col">
          <div class="custom-criteria-row">
            <div class="custom-criteria-details">
              <mat-form-field>
                <mat-label>{{ "type" | i18n }}</mat-label>
                <mat-select
                  [(ngModel)]="draft.type"
                  (ngModelChange)="onDraftTypeChange(i, $event)"
                  [name]="'newType-' + i"
                  [attr.data-cy]="'newType-' + i">
                  <mat-option [value]="customCriteriaTypeEnum.TOGGLE">{{
                    "customCriteriaTypeToggle" | i18n
                  }}</mat-option>
                  <mat-option [value]="customCriteriaTypeEnum.SELECT">{{
                    "customCriteriaTypeSelect" | i18n
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ "title" | i18n }}</mat-label>
                <input
                  matInput
                  required
                  [(ngModel)]="draft.displayName"
                  [name]="'newDisplayName-' + i"
                  [attr.data-cy]="'newDisplayName-' + i" />
              </mat-form-field>
            </div>
            <div class="custom-criteria-fields">
              <ng-container
                *ngIf="draft.type === customCriteriaTypeEnum.TOGGLE">
                <mat-checkbox
                  [(ngModel)]="draft.userEditable"
                  [name]="'newUserEditable-' + i"
                  [attr.data-cy]="'newUserEditable-' + i">
                  {{ "customCriteriaUserEditable" | i18n }}
                </mat-checkbox>
                <mat-checkbox
                  [(ngModel)]="draft.enableOnJobRequest"
                  [name]="'newEnableOnJobRequest-' + i"
                  [attr.data-cy]="'newEnableOnJobRequest-' + i">
                  {{ "customCriteriaEnableOnJobRequest" | i18n }}
                </mat-checkbox>
                <mat-slide-toggle [(ngModel)]="draft.defaultValueOnJob">
                  {{ "defaultValueForJob" | i18n }}</mat-slide-toggle
                >
                <mat-slide-toggle [(ngModel)]="draft.defaultValueOnProfile">
                  {{ "defaultValueForPooler" | i18n }}</mat-slide-toggle
                >
                <mat-checkbox
                  [(ngModel)]="draft.blockingToggle"
                  [name]="'newBlockingToggle-' + i"
                  [attr.data-cy]="'newBlockingToggle-' + i">
                  {{ "customCriteriaBlockingToggle" | i18n }}
                </mat-checkbox>
              </ng-container>
              <ng-container
                *ngIf="draft.type === customCriteriaTypeEnum.SELECT">
                <mat-checkbox
                  [(ngModel)]="draft.userEditable"
                  [name]="'newUserEditable-' + i"
                  [attr.data-cy]="'newUserEditable-' + i">
                  {{ "customCriteriaUserEditable" | i18n }}
                </mat-checkbox>
                <mat-checkbox
                  [(ngModel)]="draft.enableOnJobRequest"
                  [name]="'newEnableOnJobRequest-' + i"
                  [attr.data-cy]="'newEnableOnJobRequest-' + i">
                  {{ "customCriteriaEnableOnJobRequest" | i18n }}
                </mat-checkbox>
                <mat-checkbox [(ngModel)]="draft.multiple">
                  {{ "multipleSelection" | i18n }}</mat-checkbox
                >
                <div class="custom-criteria-options">
                  <div
                    class="custom-criteria-option-row"
                    *ngFor="
                      let option of draft.options;
                      let optionIndex = index;
                      trackBy: trackByOptionId
                    ">
                    <mat-form-field class="custom-criteria-option-field">
                      <mat-label>{{ ("title" | i18n) || "Option" }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="option.displayName"
                        [name]="'new-opt-' + i + '-' + optionIndex"
                        [attr.data-cy]="'new-opt-' + i + '-' + optionIndex" />
                    </mat-form-field>
                    <button
                      class="custom-criteria-button delete-button"
                      mat-button
                      type="button"
                      (click)="removeDraftSelectOption(i, optionIndex)"
                      [matTooltip]="('remove' | i18n) || 'Löschen'">
                      <mat-icon
                        class="custom-criteria-button-icon"
                        svgIcon="delete-trash-remove"></mat-icon>
                    </button>
                  </div>
                  <button
                    class="outline-pill-button icon-left"
                    type="button"
                    (click)="addDraftSelectOption(i)">
                    <mat-icon
                      class="custom-text-icon-button-icon"
                      svgIcon="add-circle-plus"></mat-icon>
                    {{ ("addOption" | i18n) || "Option hinzufügen" }}
                  </button>
                </div>
              </ng-container>
            </div>
            <div class="custom-criteria-buttons">
              <button
                class="custom-criteria-button"
                mat-button
                type="button"
                (click)="cancelNewCustomCriteria(i)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen'">
                <mat-icon
                  class="custom-criteria-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="custom-criteria-button save-button"
                mat-button
                type="button"
                (click)="saveNewCustomCriteria(i)"
                [matTooltip]="('save' | i18n) || 'Speichern'">
                <mat-icon
                  class="custom-criteria-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <button
            class="outline-pill-button icon-left"
            type="button"
            data-cy="add-custom-criteria-button"
            (click)="addNewCustomCriteria()">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{
              ("addCustomCriteriaGroup" | i18n) ||
                "Benutzerdefiniertes Kriterium hinzufügen"
            }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
